import { Input, Form } from "@renderbus/ui";
import { Modal } from "@/components/renderbus-modal";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import useForm from "antd/es/form/hooks/useForm";
import request from "project-config/services/request/request";
import routerUtil from "@/utils/routerUtil";
import { useGlobalStore } from "@/store/GlobalStore";
import { RenderbusModalProps } from "@renderbus/ui/components/modal";
import { useEffect } from "react";

export function RenderExchangeModal({
  modalProps,
}: {
  modalProps: RenderbusModalProps;
}) {
  const { t } = useTranslation("topup");
  const m1 = t("coupon_rule_first");
  const m2 = t("coupon_rule_second");
  const [messageApi, contextHolder] = message.useMessage();

  const { userInfo, isZh } = useGlobalStore();
  const [couponForm] = useForm();

  const { onOk, onCancel, ...otherModalProps } = modalProps;
  const handleCancel = (e: any) => {
    couponForm.resetFields();
    if (!onCancel) return;
    onCancel(e);
  };
  const { open } = otherModalProps;

  useEffect(() => {
    if (open) return;
    couponForm.setFieldValue("couponNO", "");
  }, [couponForm, open]);

  return (
    <>
      {contextHolder}
      <Modal
        title={t("coupon-title")}
        okText={t("coupon_exchange_now")}
        onOk={(e) => {
          couponForm.validateFields().then(async (values) => {
            const { couponNO } = values;
            const { message: msg, code } = await request.post(
              "/api/rendering/pay/recharge/addCouponRecord",
              {
                couponNO,
              }
            );

            if (code === 200) {
              messageApi.success(t("coupon_check_200"));
              routerUtil.navigate?.("/coupon");
              onOk?.(e);
              return;
            }

            if (code === 964) {
              const errorArr: string[] = [
                t("coupon_area_error_0"),
                t("coupon_area_error_1"),
                t("coupon_area_error_2"),
              ];
              messageApi.error(errorArr[userInfo?.zone || 0]);
              return;
            }

            if (code === 968) {
              messageApi.error(t("coupon_check_968"));
              return;
            }

            messageApi.error(t(msg || ""));
          });
        }}
        onCancel={(e) => handleCancel(e)}
        cancelButtonProps={{ hidden: true }}
        {...otherModalProps}
      >
        <Form form={couponForm} labelCol={{ span: isZh ? 3 : 5 }} colon={false}>
          {/* <CouponPrompt>
          <ExclamationCircleFilled
            style={{ margin: "3px 10px 0 0", fontSize: "15px" }}
          />
          <span>{t("coupon_old_platform_prompt")}</span>
        </CouponPrompt> */}
          <Form.Item
            name="couponNO"
            label={t("coupon_recharge_label")}
            rules={[
              { required: true, message: m1 },
              {
                pattern: new RegExp(/^[0-9a-zA-Z]{4,18}$/, "g"),
                message: m2,
              },
            ]}
          >
            <Input
              placeholder={t("coupon_recharge_placehodler")}
              className="background-2C2C31"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

// const CouponPrompt = styled.div`
//   background: rgba(255, 153, 0, 0.1);
//   padding: 5px 16px;
//   color: #ff9900;
//   margin-bottom: 24px;
//   display: flex;
// `;
